import { render, staticRenderFns } from "./JFilePop.vue?vue&type=template&id=0cd7ff09&scoped=true"
import script from "./JFilePop.vue?vue&type=script&lang=js"
export * from "./JFilePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd7ff09",
  null
  
)

export default component.exports